<template>
  <VLoader />
</template>

<script>
import VLoader from '@/components/base/VLoader';

export default {
  name: 'Logout',
  components: { VLoader },
  mounted() {
    this.$store.commit('auth/logout');
    window.location = '/';
  },
};
</script>
